import { NewPeriodSelectorIntervalType } from '../../enums/newPeriodSelectorIntervalType';
import { NewPeriodSelectorInterval } from '../../enums/newPeriodSelectorInterval';

export class NewPeriodFilter {
    periodIntervalType: NewPeriodSelectorIntervalType;
    periodInterval: NewPeriodSelectorInterval;
    formattedPeriod: string;
}
